import React, {useEffect, useRef, useState} from 'react';
import VisitRequest from './components/VisitRequest';
import VisitorDetailGeneralForm from './components/VisitorDetailGeneralForm';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {VisitRequestApi} from "../../../../../modules/vms/api/VisitRequestApi";
import {MessageUtils} from "../../../../../utils/MessageUtils";
import {Button, Stack} from "@mui/material";
import SubmitButton from "../../../../../components/buttons/SubmitButton";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";
import {ValidateUtils} from "../../../../../utils/ValidateUtils";
import PageTitle from "../../../../../components/PageTitle";
import LoadingBackdrop from "../../../../../components/LoadingBackdrop";
import dayjs from "dayjs";
import {Formats} from "../../../../../constants/Formats";
import {UserDto} from "../../../../../modules/account/dto/UserDto";
import {UserApi} from "../../../../../modules/account/api/UserApi";
import {VisitorAttachFileClassify} from "../../../../../modules/vms/enums/VisitorFileClassify";
import {ApplySourceType} from "../../../../../modules/vms/enums/ApplySourceType";

const Index: React.FC = () => {
    const intl = useIntl();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());

    const [visitRequest, setVisitRequest] = useState(new VisitRequestDto());
    const [requestVisitor, setRequestVisitor] = useState(new RequestVisitorDto());
    const [loading, setLoading] = useState(false);
    const [sessionUser, setSessionUser] = useState<UserDto>(new UserDto());

    useEffect(() => {
        fetchSessionUser();

        const newVisitRequest = {...visitRequest};
        newVisitRequest.applySourceType = ApplySourceType.Enum.EmployeeWeb;
        newVisitRequest.arriveStartDate = dayjs().format(Formats.DATE_SIMPLE);
        newVisitRequest.arriveEndDate = newVisitRequest.arriveStartDate;
        newVisitRequest.arriveStartTime = '000000';
        newVisitRequest.arriveEndTime = '235959';
        newVisitRequest.classify = VisitRequestClassify.Enum.EmployeeVehicle;
        setVisitRequest(newVisitRequest);
    }, []);

    const fetchSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setSessionUser(responseResult.data);

            const newRequestVisitor = {...requestVisitor};
            newRequestVisitor.lastName = responseResult.data.lastName;
            newRequestVisitor.firstName = responseResult.data.firstName;
            newRequestVisitor.mobile = responseResult.data.mobile;
            newRequestVisitor.email = responseResult.data.email;
            setRequestVisitor(newRequestVisitor);
        }
    };

    const handleSubmit = async () => {
        if (!validate()) {
            return;
        }
        setLoading(true);
        if (requestVisitor.attachFilesArray.length > 0) {
            requestVisitor.attachFiles = JSON.stringify(requestVisitor.attachFilesArray);
        }
        visitRequest.visitors.push(requestVisitor);
        const responseResult = await VisitRequestApi.registerEmployeeVehicleRequest(visitRequest);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'VMS_VISIT_REQUEST_EMPLOYEE_VEHICLE_SUBMIT_SUCCESS'}));
            handleReset();
        }
        setLoading(false);
    };

    const handleReset = () => {
        setVisitRequest(new VisitRequestDto());
        setRequestVisitor(new RequestVisitorDto());
    };

    const handleChange = (name: string, value: any) => {
        setVisitRequest({...visitRequest, [name]: value});
    };

    const handleChangeVisitor = (name: string, value: any) => {
        setRequestVisitor({...requestVisitor, [name]: value});
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();

        if (requestVisitor.lastName === '') {
            newMessageMap.set('lastName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED'}));
        }
        if (requestVisitor.firstName === '') {
            newMessageMap.set('firstName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED'}));
        }
        if (requestVisitor.plateNumber === '') {
            newMessageMap.set('plateNumber', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED'}));
        }

        // 验证证件
        let hasDriverLicense = false;
        let hasVehicleLicense = false;
        for (let attachFile of requestVisitor.attachFilesArray) {
            if (attachFile.classify === VisitorAttachFileClassify.Enum.DriverLicense) {
                hasDriverLicense = true;
            } else if (attachFile.classify === VisitorAttachFileClassify.Enum.VehicleLicense) {
                hasVehicleLicense = true;
            }
        }
        if (!hasDriverLicense) {
            newMessageMap.set('attachFileDriverLicense', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD_REQUIRED'}));
        }
        if (!hasVehicleLicense) {
            newMessageMap.set('attachFileVehicleLicense', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD_REQUIRED'}));
        }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    return (
        <div>
            <LoadingBackdrop open={loading} onClick={() => setLoading(false)}/>
            <PageTitle title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY_EMPLOYEE_VEHICLE'})}/>
            <VisitRequest applicant={sessionUser}/>
            <br/>
            <VisitorDetailGeneralForm requestVisitor={requestVisitor} messageMap={messageMap}
                                      onChange={handleChangeVisitor}/>
            <br/>
            <Stack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
                <SubmitButton onClick={handleSubmit}/>
            </Stack>
        </div>
    );
};

export default Index;
